@if (contentlet()) {
<div class="product-list-container" [ngClass]="contentlet().cssClass">
  <custom-dot-cms-uve-product-carousel-list listStyle="carousel" listItemStyle="tile" [contentlet]="contentlet()" />
</div>
}
